export function capitalize(input: string) {
  let words = input.split(' ');
  let CapitalizedWords: any = [];
  words.forEach((element) => {
    const trimElement = element.trim();
    if (trimElement.length > 0) {
      CapitalizedWords.push(
        trimElement[0].toUpperCase() + trimElement.slice(1, trimElement.length)
      );
    }
  });
  return CapitalizedWords.join(' ');
}
